

















































import Vue from 'vue'
import FormDialog, { iFormDialogOptions } from '@/components/FormDialog.vue'
export default Vue.extend({
  name: 'settings',
  components: {
    FormDialog
  },
  data() {
    return {
      loadDone: false,
      settings: null,
      settingsDialogOptions: null,
      hasChanged: false
    }
  },
  created() {
    this.reload()
  },
  methods: {
    async reload(local = true) { 
      try {
        this.loadDone = false
        let tasks: any[] = []
        tasks.push(this.$store.dispatch('setting/getList', { local, query: { 
          limit: 0,
          order: { createdAt: 1 }
        } }).then(res => {
          this.settings = [...res.map((x, i) => ({
            ...x, index: i,
            values: (x.value && x.type=='object')?Object.keys(x.value)
            .map(key => ({ key, value: x.value[key] })):null
          }))]
        }))
        await Promise.all(tasks)
        console.log(this.settings)
        this.total = this.$store.getters['setting/total']
      } catch (err) {
        this.$store.dispatch('error/handleError', err, 'Lấy cấu hình hệ thống thất bại')
      } finally {
        this.loadDone = true
      }
    },
    openSetting(setting) {
      this.settingsDialogOptions = {
        title: setting?"Chỉnh sửa cấu hình":"Tạo cấu hình",
        confirmText: setting?"Chỉnh sửa cấu hình":"Tạo cấu hình mới",
        confirmFn: async data => {
          if (data) {
            try {
              let newData = {...data}
              if (setting) {
                switch (data.type) {
                  case 'string': newData.value = setting.type=='string'?setting.value:''; break;
                  case 'object': newData.value = data.values.reduce((obj, item) => { 
                    obj[item] = setting.value[item] ? setting.value[item] : ''
                    return obj 
                  }, {})
                  break;
                }
                delete newData.values
                let result = await this.$store.dispatch("setting/update", {
                  id: setting._id,
                  data: newData
                });
                let settings = this.settings
                let index = settings.findIndex(x => x._id == setting._id)
                if (index >= 0) {
                  if (result.type == 'object') result.values = Object.keys(result.value).map(x => ({ key: x, value: setting.value[x] }))
                  settings[index] = result
                  this.settings = [...settings];
                }
              } else {
                switch (data.type) {
                  case 'string': newData.value = ''; break;
                  case 'object': console.log(data.values); newData.value = data.values.reduce((obj, item) => { 
                    obj[item] = ''
                    return obj 
                  }, {} )
                  break;
                }
                delete newData.values
                let result = await this.$store.dispatch("setting/add", newData);
                if (result.type == 'object') result.values = data.values.map(x => ({ key: x, value: '' }))
                this.settings = [...this.settings, result];
              }
            } catch (err) {
              let message = err.code == 500 ? "Mã cấu hình bị trùng" : "";
              this.$store.dispatch(
                "error/handleError",
                err,
                "Thêm cấu hình thất bại",
                message
              );
            }
          }
        },
        fields: [
          {
            label: "Mã cấu hình",
            property: "code",
            col: "is-4",
            required: true,
            readonly: setting ? true : false,
            current: setting ? setting.code : ''
          },
          {
            label: "Tên cấu hình",
            property: "desc",
            col: "is-5",
            required: true,
            current: setting ? setting.desc : ''
          },
          {
            label: "Loại cấu hình",
            property: 'type',
            type: 'select',
            options: [
              { code: 'string', display: 'Chữ' },
              { code: 'number', display: 'Số' },
              { code: 'object', display: 'Tùy chỉnh' }
            ],
            col: "is-3",
            current: setting ? setting.type : 'string',
            propsMutation: {
              properties: ['values'],
              type: 'hidden',
              conditionFn: val => val != 'object'
            }
          }, {
            label: 'Danh sách thuộc tính tùy chỉnh',
            property: 'values',
            type: 'list',
            col: 'is-12',
            placeholder: 'Nhập thêm tùy chỉnh',
            current: (setting && setting.values) ? setting.values.map(x => x.key) : []
          }
        ]
      } as iFormDialogOptions
    },
    async deleteSetting(setting) {
      if (!setting) return;
      if (
        !(await this.$confirm(
          "Bạn có muốn xóa cấu hình " + setting.desc + " không?",
          "Xóa cấu hình",
          "question"
        ))
      )
        return;

      let settings = this.settings
      let index = settings.findIndex(x => x._id == setting._id)
      try {
        settings.splice(index, 1)
        await this.$store.dispatch("setting/delete", setting._id)
      } catch (err) {
        this.settings.splice(index, 0, setting)
        this.$store.dispatch("error/handleError", err, "Xóa thất bại");
      }
    },
    async valueChanged(setting, value, key = null) {
      let newValue
        let index = this.settings.findIndex(x => x._id == setting._id)
      switch(setting.type) {
        case 'string': {
          newValue = value.toString()
          break
        }
        case 'number': {
          newValue = Number(value)
          break;
        }
        case 'object': {
          setting.value[key] = value.toString()
          newValue = {...setting.value}
          break
        }
      }
      try {
        let result = await this.$store.dispatch("setting/update", {
          id: setting._id,
          data: { value: newValue }
        })
        if (index >= 0) {          
          if (setting.type == 'object') {
            this.settings[index].values = Object.keys(newValue).map(x => ({ key: x, value: newValue[x] }))
          } else {
            this.settings[index].value = newValue
          }
          this.settings = [...this.settings]
        }
      } catch (err) {

      }
    }
  }
})
